import InputRadio from './input-radio-view'

export default InputRadio
